import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { PayService } from '../../invoices/pay.service';
import { PopoverController } from '@ionic/angular';
import { DialogService } from '../../_services/dialog.service';
import { InvoicePaySelectVidsComponent } from '../invoice-pay-select-vids/invoice-pay-select-vids.component';
import { AppDialogsService } from '../../_services/appDialogsService';
import { DataService } from '../../_services';
import { AppMultipartFileUploadComponent } from '../../_shared/app-multipart-file-upload/app-multipart-fille-upload.component';
import { TranslateService } from '@ngx-translate/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'invoice-pay-amt-change',
  templateUrl: './invoice-pay-amt-change.component.html',
})
export class InvoicePayAmtChangeComponent implements OnInit {



  // private enterValueForCourierCharges : string = this.translate.instant('MESSAGES.ENTER_VALUE_FOR_COURIER_CHARGES');
  // private tdsLessThan : string = this.translate.instant('MESSAGES.TDS_LESS_THAN');
  private totalOfDeductions : string = this.translate.instant('MESSAGES.TOTAL_OF_DEDUCTIONS');
  private andPayingAmount : string = this.translate.instant('MESSAGES.AND_PAYING_AMOUNT');
  private shouldBeEqualToInvAmt : string = this.translate.instant('MESSAGES.SHOULD_BE_EQUAL_TO_INV_AMT');
  private amtExceedsInvoiceBy : string = this.translate.instant('MESSAGES.AMOUNT_EXCEEDS_INVOICE_BY');
  private differenceOfAmount : string = this.translate.instant('MESSAGES.DIFFERENCE_OF_AMOUNT');

  @Input() payData: any = {};
  formSubmitted = false;
  payModel: any;
  payConfig: any = {};
  partialPayReason = undefined;
  partialPayFormInvalid = false;

  // partialPayReason = '';
  partialOtherReason = '';
  // partialPayFormInvalid = false;
  scfFormInvalid = false;
  partialPayInvalidMSG = '';
  totalOfPayAmtAndDA = 0;
  scfData;
  scfFormRequired = false;
  scfFormField = '';
  scfConfig = [];
  scfErrors = {};
  scfFields = [];
  selectedVids = {};
  selectedFiles = '';
  selectedFileName = '';

  formError = undefined;
  @ViewChild('fileUploadComponent') fileUploadComponent !: AppMultipartFileUploadComponent;

  constructor(
    private payService: PayService,
    private modal: PopoverController,
    public popOverCntrl: PopoverController,
    private appDialogsService: AppDialogsService,
    private dialogService: DialogService,
    private dataService: DataService,
    private translate: TranslateService,
    public activeModal: NgbActiveModal
  ) { }

  ngOnInit() {
    this.payModel = this.payData.payData.payModel;
    this.payData.payData.initPartialPay();
    // Compute the running deduction totals so the footer strip is populated on open.
    this.payService.processDeductions(this.payData.payData, true);
    this.payConfig = this.payData.payData.payConfig;
    this.scfFormRequired = this.payData.payData.invoiceData.isSCFormRequired;
    this.scfConfig = this.payData.payData.invoiceData.scfFormConfig;
    if (this.scfFormRequired && this.scfConfig) {
      this.initSCFFormData();
      // Special case for Rieter
      if (this.payData.payData.invoiceData.payEditDisabled) {
        this.payModel.partialAmt = this.payData.payData.invoiceData.BA;
      }
    }
  }

  initSCFFormData() {
    let hasVidSelection = false;
    const dontResetPartialPay = this.payData.payData.invoiceData.dontResetPartialPay;
    this.scfFields = this.scfConfig.map(scfconfigItem => {
      scfconfigItem.vidsSelected = dontResetPartialPay ? scfconfigItem.vidsSelected : [];
      if (scfconfigItem.vidSelection) {
        hasVidSelection = true;
        this.payModel[scfconfigItem.vidKey] = dontResetPartialPay ? this.payModel[scfconfigItem.vidKey] : undefined;
      }
      return scfconfigItem.key;
    });
    this.scfData = this.payService.initSCFForm();
    this.scfData.initSCFAmounts(this.payModel, this.scfFields, dontResetPartialPay);
    this.scfData.getTotalAmt(this.payModel, this.scfFields);
    if (hasVidSelection) {
      //get vids in memory to avoid dialog height issue.
      this.payService.getVIDsForInvoice(this.payData.payData).subscribe(data => {
      });
    }
  }

  checkCourierCharges(courierChargeValue, fileUploadComponent, event) {
    if (courierChargeValue) {
      if (parseInt(courierChargeValue, 10) > 0) {
        // allow file upload
        fileUploadComponent.openFileSelection();
        event.stopPropagation();
      } else {
        this.dialogService.showMessageDialog(this.translate.instant('MESSAGES.ENTER_VALUE_FOR_COURIER_CHARGES'));
      }
    }
  }

  selectFile(fileData) {
    this.payModel.courierReceipt = fileData;
  }

  clearSCFCourierFile() {
    this.payModel.courierReceipt = undefined;
    this.fileUploadComponent.clearFile();
  }

  setPayamount(invoicePayAmtForm) {
    if (invoicePayAmtForm.form && invoicePayAmtForm.form.valid) {
      const err = this.payData.payData.validatePartialPayAmount(parseFloat(this.payModel.editableAmt));
      if (err) {
        this.dialogService.showErrorModal({ message: err });
      } else {
        //set SCF data here
        if (this.payData.payData.invoiceData.isSCFormRequired) {
          this.payService.setSCFData(this.payModel, this.scfConfig);
          this.doCDCallWithTDS();
        }
        this.payData.payData.partialReason = this.payModel.partialOtherReason || this.partialPayReason;
        this.payData.payData.setPartialAmt(parseFloat(this.payModel.editableAmt));
        this.close();
      }
    }
  }

  doCDCallWithTDS() {
    // this.payData.getCashDiscount(this.payData);
    this.payData.payData.getCashDiscount(this.payData.payData.invoiceData.invoice, this.payData.payData.payModel.payDate, this.payData.payData);
  }

  checkEditableAmt() {
    this.formError = undefined;
    let amt = parseFloat(this.payModel.editableAmt || 0);
    // for special rieter case
    if (this.payData.payData.invoiceData.payEditDisabled) {
      const partialAmt = parseFloat(this.payModel.partialAmt || 0);
      amt = partialAmt - parseFloat(this.payModel.TDS || 0);
      if (amt < 0) {
        amt = 0;
      }
      this.payModel.editableAmt = this.dataService.roundNumToTwoDecimalPlace(amt);
    }
    const msg = this.payData.payData.validatePartialPayAmount(amt);
    if (msg) {
      this.formError = msg;
    } else {
      if (!this.payData.payData.invoiceData.payEditDisabled) {
        this.checkTotalDeductionApplied();
      }
    }
    if (!this.payModel.CCharges || parseInt(this.payModel.CCharges, 10) <= 0) {
      this.clearSCFCourierFile();
    }
  }

  checkTotalDeductionApplied() {
    if (this.scfFormRequired) {
      this.scfErrors = {};
      this.scfFormInvalid = false;
      const totalDeductionApplied = this.scfData.getTotalAmt(this.payModel, this.scfFields);
      const totalAmt = totalDeductionApplied + parseFloat(this.payModel.editableAmt);
      const diff = this.payData.payData.invoiceData.BA - totalAmt;
      const tenPercentOfInvoiceBalance = (this.payData.payData.invoiceData.BA * 0.1);
      if (!this.payConfig.skipTDSCheck) {
        if (parseFloat(this.payModel.TDS) > tenPercentOfInvoiceBalance) {
          this.scfErrors['TDS'] = this.translate.instant('MESSAGES.TDS_LESS_THAN')
          this.scfFormInvalid = true;
        }
      }
      if (this.payData.payData.invoiceData.BA !== totalAmt) {
        this.scfErrors['DA'] = `${this.translate.instant("LABELS.INVOICE_KNOCK_OFF_MESSAGE", {deductions: this.dataService.displayNumberAsCurrency(totalDeductionApplied), amountPaying: this.dataService.displayNumberAsCurrency(parseFloat(this.payModel.editableAmt)),
          invoiceAmount: this.dataService.displayNumberAsCurrency(this.payData.payData.invoiceData.BA),
          remark: (diff < 0) ? this.translate.instant('LABELS.INVOICE_EXCEEDING_MESSAGE', {amount: this.dataService.displayNumberAsCurrency(-diff)}) : this.translate.instant('LABELS.INVOICE_DECREASING_MESSAGE', {amount: this.dataService.displayNumberAsCurrency(diff)}) })}`
        this.scfFormInvalid = true;
      }
    }
  }

  setTDSBasedOnPartialPayAmt() {
    const difference = this.payData.payData.invoiceData.BA - parseFloat(this.payModel.editableAmt);
    if (difference > 0) {
      this.payModel.TDS = this.dataService.roundNumToTwoDecimalPlace(difference);
    }
  }

  setPartialAmtBasedOnTDS() {
    const difference = this.payData.payData.invoiceData.BA - parseFloat(this.payModel.TDS);
    if (difference > 0) {
      this.payModel.editableAmt = this.dataService.roundNumToTwoDecimalPlace(difference);
    }
  }

  close() {
    // this.clearDeductions();
    this.resetSCFForm();
    this.activeModal.close();
  }

  closeModal(){
    this.clearDeductions();
    this.resetSCFForm();
    this.activeModal.close();
  }

  //special case for opening modal, since this is modal on modal app dialogs service is not handling it well
  async openVIDSelectionDialog(scfField) {
    const modal = await this.popOverCntrl.create({
      component: InvoicePaySelectVidsComponent,
      backdropDismiss: false,
      componentProps: {
        payModel: this.payModel,
        scfField: scfField,
        payData: this.payData.payData
      },
      cssClass: ['partialPayContainer']
    });
    modal.onDidDismiss().then((result) => {
      this.checkTotalDeductionApplied();
    });
    return await modal.present();
  }

  resetSCFField(scfField) {
    this.payModel[scfField.key] = 0;
    scfField.vidsSelected = [];
    if (scfField.desc === 'COURIER CHARGES') {
      this.clearSCFCourierFile();
    }
  }

  resetSCFForm() {
    //Check for invalid form, when user is trying to close it for scf payments
    if (this.payData.payData.invoiceData.dontResetPartialPay) {
      if (this.scfFormInvalid) {
        //TODO
        //Service work in controller
        this.payData.payData.invoiceData.dontResetPartialPay = false;
        this.payData.payData.initPartialPay();
        this.initSCFFormData();
        this.payData.payData.setPartialAmt(parseFloat(this.payModel.editableAmt));
        this.payService.setSCFData(this.payModel, this.scfConfig);
      }
    }
  }

  // addDeduction(invoice) {
  //   if (this.payService.validateDeduction(this.payData, invoice)) {
  //     this.payService.addDeductionToInvoice(this.payData, invoice);
  //   };
  // }

  // validateDeductionModel(invoice) {
  //   invoice.deductionModel.isValid = this.payService.validateDeduction(this.payData, invoice);
  // }

  // removeDeduction(invoice, deductionIndex) {
  //   this.payService.removeDeduction(this.payData, invoice, deductionIndex);
  // }

  clearDeductions() {
    this.payService.clearDeductions(this.payData.payData);
  }

  setPayableAmountAfterDeductions() {
    this.payData.payData.setPartialAmt(this.payData.payData.invoiceData.BA - this.payData.payData.totalDeductionForAllInvoices);
    this.close();
  }

}

